// Libraries
import React, { Component } from "react";
import Modal from "react-modal";
import { Image } from "image-js";

// Child Component
import Orientation from "./orientation";

// Modal Component
var appElement = document.getElementById("root");
Modal.setAppElement(appElement);

class Viewpoint extends Component {
  constructor(props) {
    super(props);
    this.state = { modalIsOpen: false };

    this.state = {
      background: undefined,
      original: undefined,
      image: undefined,
      mask: undefined,
      selectedImages: undefined,
      width: 0,
      height: 0,
      alpha: 0,
      beta: 0,
      gamma: 0,
      latitude: 0,
      longitude: 0,
    };
  }

  async componentDidMount() {
    // Empty Image Load
    this.toDataImage(`${process.env.PUBLIC_URL}/msc/view.png`).then(
      (dataUrl) => {
        this.setState({ background: dataUrl });
      }
    );

    // Main Image Load
    this.toDataImage(this.props.inputImage).then((inputImage) => {
      this.setState({ original: inputImage });
      // Run Edge Detection on Image when Component Mounted
      this.execute(inputImage).catch((e) => console.log(e));
    });

    // GeoLocation Data Load
    navigator.geolocation.getCurrentPosition((position) => {
      this.setState({
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      });
    });
  }

  static getDerivedStateFromProps(props, state) {
    if (props.capturedImage !== state.image) {
      return {
        image: props.capturedImage,
      };
    }
    return null;
  }

  // Image Load Function form External URL
  toDataImage = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  // Image Proccessing
  async execute(imageSrc) {
    // Oprions
    const guassian_options = {
      radius: 5,
      sigma: 0.6,
    };

    const mask_options = {
      algorithm: "threshold",
      threshold: 80,
      useAlpha: true,
      invert: true,
    };

    const paint_options = {
      color: [254, 192, 0],
      alpha: 255,
    };

    // Load image Blob
    let image = await Image.load(imageSrc);

    // Get Image Dimentions
    const originalWidth = image.width;
    const originalHeight = image.height;

    // Edge Detection
    let mask = image
      .grey()
      .gaussianFilter(guassian_options)
      .sobelFilter()
      .dilate()
      .erode()
      .invert()
      .mask(mask_options);

    // Define a new Image
    let filter = new Image(originalWidth, originalHeight);
    filter.src = this.state.background;
    let paintedMask = filter
      .paintMasks(mask, paint_options)
      .toDataURL("image/png");

    this.setState({
      mask: paintedMask,
      width: originalWidth,
      height: originalHeight,
    });
  }

  // Open Modal Function
  openModal = () => {
    this.setState({ modalIsOpen: true });
  };

  // Close Modal Function
  closeModal = () => {
    this.setState({ modalIsOpen: false });
  };

  // Modal Close Event Handler
  handleModalCloseRequest = () => {
    this.setState({ modalIsOpen: false });
  };

  // Modal Save Event Handler
  handleSaveClicked = (event) => {
    // event.preventDefault();
    this.props.saveModal(this.state);

    this.setState({ modalIsOpen: false });
  };

  // Captue Image and Get Orientation
  handleSetOrientation = async (orientation) => {
    await this.props.capture();

    this.setState({
      alpha: orientation.alpha,
      beta: orientation.beta,
      gamma: orientation.gamma,
    });
  };

  render() {
    return (
      <div>
        <div className="row">
          <div className="col-sm-12">
            <button
              type="button"
              className="btn btn-block btn-warning rounded"
              onClick={this.openModal}
            >
              Get Orientation
            </button>
          </div>
        </div>
        <Modal
          className="Modal__Bootstrap modal-dialog"
          closeTimeoutMS={150}
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.handleModalCloseRequest}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" style={{ color: "white" }}>
                Viewpoint Orientation Cache
              </h5>
              <button
                type="button"
                className="close"
                onClick={this.handleModalCloseRequest}
              >
                <span aria-hidden="true">
                  <i className="bx bx-x"></i>
                </span>
                <span className="sr-only">Close</span>
              </button>
            </div>
            <div className="modal-body">
              <div
                className={
                  this.state.image
                    ? "horizontal before-after-container"
                    : "horizontal"
                }
              >
                <Orientation
                  original={this.state.original}
                  width={this.state.width}
                  height={this.state.height}
                  image={this.state.image}
                  mask={this.state.mask}
                  capture={this.props.capture}
                  retake={this.props.retake}
                  getOrientation={this.handleSetOrientation}
                />
              </div>
              <div className="vertical">
                <video
                  autoPlay={true}
                  controls={false}
                  loop={true}
                  muted={true}
                  style={{ maxWidth: "100%", height: "100%" }}
                >
                  <source
                    src={`${process.env.PUBLIC_URL}/msc/rotate.mp4`}
                    type="video/mp4"
                  />
                </video>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary rounded"
                onClick={this.handleModalCloseRequest}
              >
                Discard
              </button>
              <button
                type="button"
                className="btn btn-success rounded"
                onClick={this.handleSaveClicked}
              >
                Save Changes
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default Viewpoint;
